import { Header, Page } from 'redesign';
import { PartnerFilterToolbox } from './components/partner-filter-toolbox/partner-filter-toolbox';
import { PARTNERS_FILTER_INITIAL_VALUE } from './partners.types';
import { PartnersList } from './partners-list';
import { useExternalParams } from '../../../../shared/hooks';

const Partners = () => {
  const [params, setParams] = useExternalParams(PARTNERS_FILTER_INITIAL_VALUE);

  return (
    <Page
      header={<Header titleText="Partners" />}
      toolbox={<PartnerFilterToolbox params={params} setParams={setParams} />}
    >
      <PartnersList params={params} />
    </Page>
  );
};

export { Partners };
